import { apiService } from "./apiService";
import { ITermsOfUse, TermsOfUseUserStatus } from "../types/termsOfUse";

export const TermsOfUseService = {
    saveFile: (base64: string) =>
        apiService.post('/api/termsofuse/file', { termsOfUse: { base64 } }).then(res =>
            res.status && res.status === 200 && res.data && res.data.successful),
    getCurrentTermsOfUse: () =>
        apiService.get('/api/termsofuse').then(res =>
            res.status && res.status === 200 && res.data.termsOfUse ? res.data.termsOfUse as ITermsOfUse : null),
    getUserAgreementStatus: (email: string) =>
        apiService.get(`/api/termsofuse/status/${email}`).then(res =>
            res.status && res.status === 200 && res.data && res.data.status as TermsOfUseUserStatus),
    saveAcceptanceUser: (id: string) =>
        apiService.post('/api/termsofuse/user', { termsOfUse: { id } }).then(res =>
            res.status && res.status === 200 && res.data && res.data.successful)
}
